function scrollIdIntoView(id) {
  var scrollTarget = document.getElementById(id);
  scrollTarget.scrollIntoView({ behavior: 'smooth', block: 'center' });
}

/* ====================================================================
 * Lightgallery init
 * ==================================================================== */
jQuery(document).ready(function($) {
  $('.js-lightgallery').lightGallery({
    selector: '.js-lightgallery__item',
  });
});

/* ====================================================================
 * Owl.Carousel.2 init
 * ==================================================================== */
jQuery(document).ready(function($) {
  var carousel = $('.js-carousel-full');
  carousel.owlCarousel({
    items: 1,
    nav: false,
    loop: true,
  });

  $('.js-owl-prev').click(function() {
    carousel.trigger('prev.owl.carousel');
  });

  $('.js-owl-next').click(function() {
    carousel.trigger('next.owl.carousel');
  });
});
